var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_200_7937",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 18,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 2.5H18.7269V18.7508H1.6665L1.6665 2.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_200_7937)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18647 10.1026C4.3548 13.7376 8.97063 16.6768 10.1973 17.4043C11.4281 16.6693 16.0773 13.6976 17.2081 10.1059C17.9506 7.78427 17.2615 4.84343 14.5231 3.96093C13.1965 3.5351 11.649 3.79427 10.5806 4.62093C10.3573 4.7926 10.0473 4.79593 9.8223 4.62593C8.69064 3.7751 7.2123 3.52593 5.8648 3.96093C3.13063 4.8426 2.44397 7.78343 3.18647 10.1026ZM10.1981 18.7509C10.0948 18.7509 9.9923 18.7259 9.89897 18.6751C9.63813 18.5326 3.49397 15.1459 1.99647 10.4843C1.99563 10.4843 1.99563 10.4834 1.99563 10.4834C1.05563 7.54843 2.1023 3.8601 5.48147 2.77093C7.06813 2.2576 8.7973 2.48343 10.1956 3.36593C11.5506 2.50927 13.3506 2.2726 14.9056 2.77093C18.2881 3.86177 19.3381 7.54927 18.399 10.4834C16.9498 15.0918 10.7606 18.5293 10.4981 18.6734C10.4048 18.7251 10.3015 18.7509 10.1981 18.7509Z",
    fill: "#6261AF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1277 8.85406C14.8052 8.85406 14.5319 8.60656 14.5052 8.27989C14.4502 7.59489 13.9919 7.01656 13.3394 6.80573C13.0102 6.69906 12.8302 6.34656 12.9361 6.01906C13.0436 5.69073 13.3927 5.51239 13.7227 5.61573C14.8586 5.98323 15.6544 6.98906 15.7519 8.17823C15.7794 8.52239 15.5236 8.82406 15.1794 8.85156C15.1619 8.85323 15.1452 8.85406 15.1277 8.85406Z",
    fill: "#6261AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBlue);
export default __webpack_public_path__ + "static/media/HeartBlue.4ce29473eeaca1e98a2b3ee45ffc8290.svg";
export { ForwardRef as ReactComponent };